interface AdsenseConfig {
  client: string
  slots: {
    testing: string
    landing: string
    content: string
    error: string
  }
  channels: {
    cam?: string
    mic?: string
    headphones?: string
  }
}

const adsenseConfigBy: AdsenseConfig = {
  client: 'ca-pub-6959294419160119',
  slots: {
    testing: '2240089022',
    landing: '4253027748',
    content: '2583118190',
    error: '5191796200',
  },
  channels: {
    cam: '8956079146',
    mic: '2422130818',
    headphones: '1895846770',
  },
}

const adsenseConfigUa: AdsenseConfig = {
  client: 'ca-pub-4733833642011475',
  slots: {
    testing: '8769970211',
    landing: '7467062654',
    content: '7773727512',
    error: '2948776242',
  },
  channels: {
    cam: '1602220774',
    mic: '2763738136',
    headphones: '6662975766',
  },
}

const adsenseConfigGe: AdsenseConfig = {
  client: 'ca-pub-1841927605624409',
  slots: {
    testing: '3133756761',
    landing: '3133756761',
    content: '3133756761',
    error: '3133756761',
  },
  channels: {},
}

const adsenseConfigCy: AdsenseConfig = {
  client: 'ca-pub-8311821857214729',
  slots: {
    testing: '5938526267',
    landing: '5938526267',
    content: '5938526267',
    error: '5938526267',
  },
  channels: {},
}

export const adsenseConfig = adsenseConfigCy
